export default "__VITE_ASSET__B8Ysr1Sk__"